// absolute imports
import Vue from 'vue';
import Vuex from 'vuex';

import VueSession from 'vue-session';
import VueAxios from 'vue-axios';
import InfiniteScroll from 'v-infinite-scroll';
import Snotify, { SnotifyPosition } from 'vue-snotify';

import moment from 'moment';
import bootstrap from 'bootstrap';
import jQuery from 'jquery';
import lodash from 'lodash';

import 'v-infinite-scroll/dist/v-infinite-scroll.css';
import 'vue-snotify/styles/material.css';

// relative imports
import App from './App';
import router from './router';
import store from './stores/index';

import axios from './plugins/axios';

import "./mixins/functions";
import "./mixins/filters";

Vue.use(VueAxios, axios);
Vue.use(Vuex);
Vue.use(VueSession, { persist: true });
Vue.use(InfiniteScroll)
Vue.use(Snotify, { toast: { position: SnotifyPosition.rightTop }});

window.jQuery = jQuery;
window._ = lodash;
window.bootstrap = bootstrap;

Vue.prototype.moment = moment;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
